import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useEffect, useState, useContext } from 'react';
import { MessagesContext } from "../common/context";

// import { graph } from '@pnp/graph';
// import { WebPartContext } from "@microsoft/sp-webpart-base";

import * as Fabric from 'office-ui-fabric-react';
import { Link, initializeIcons, ActivityItem, Icon,  mergeStyleSets } from 'office-ui-fabric-react';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { TextField } from "office-ui-fabric-react";
import { escape } from '@microsoft/sp-lodash-subset';
import { PIVOT_KEY } from '../common/consts';
import { replyBodyStyle, replyStyle } from "./Reply.Styles";
import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import  * as uuidv4 from "uuid/v4";
//import "../../styles.css";
 
export  function Reply({ teamID, channelId, messageId, reply, accessToken }) {

    const {state,dispatch} = useContext(MessagesContext);
    const [isChecked, setIsChecked] = useState(false);
    const [showReplyContent, setShowReplyContent] = useState(false);

    log.info(` @ Reply`);

    const replyText = reply.text.substr(0,100);
    React.useEffect(() => {
        log.info(`useEffect @ Reply`);
        isChecked && addItem(); 
      }, [isChecked]);

      const handleToItemsR = ()=>{
        log.info(`handleToItemsR @ Reply`); 
        setIsChecked(!isChecked); 
    }
    const addItem = () =>{
        log.info(`addItem @ Reply`); 
        const _message = {
          id: uuidv4(),
          date: reply.date,
          text : reply.text,
          webUrl : reply.webUrl,
          user : reply.user,
          type : reply.type,
          selected: reply.selected
      };
        dispatch({ type: "ADD_MESSAGE", payload: _message });
        const ___payload = { pivotKey:  PIVOT_KEY.ITEMS};
        dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
      }

    initializeIcons();

    const handleReplyWebUrl = ()=>{
      log.info(`handleReplyWebUrl @ Reply`);       
      window.open(reply.webUrl, '_blank')
   }

   const _items = [
    {
      key: 'perona',
      text: reply.user,
      iconOnly: true,
      iconProps: { iconName: 'Contact' },
    },
    {
      key: 'open',
      text: 'Open in Teams',
      iconOnly: true,
      iconProps: { iconName: 'OpenInNewTab' },
       onClick: () => {
         handleReplyWebUrl();
       }
     },
     {
       key: 'title',
       iconProps: { iconName: 'Message' },
       text: `${reply.text.replace( /(<([^>]+)>)/ig, '').substr(0,50)}`,
      onClick: () => {setShowReplyContent(!showReplyContent)}
     }

   ];

   const _farItems = [
     {
       key: 'toItemsR',
       text: 'Copy Reply to Items',
       iconOnly: true,
       iconProps: { iconName: 'Copy' },
       onClick:  ()=>{ handleToItemsR(); } 
     }
   ];
   

   const renderReplyBar=()=>{
     return (
             <div style={replyStyle()} >
             <CommandBar
                     items={_items}
                     farItems={_farItems}
                   />
             </div>
             );  
   };


   const renderReply=()=>{
    return (
      showReplyContent ? 
            (                       
            <div style={replyBodyStyle()}>
              {reply.text.replace( /(<([^>]+)>)/ig, '')}
            </div>    
            ) : ''
            );  
  };

    return (
    <>
      { renderReplyBar() }
      { renderReply() }
    </>

    );
}














            // <TextField
            //           key={uuidv4()}
            //           value={reply.text.replace( /(<([^>]+)>)/ig, '')}
            //           readOnly
            //           resizable={true}
            //           multiline
            //           autoAdjustHeight
            //           style={replyBodyStyle()}
            //         >
            //         </TextField>




      {/* {activityItemExamples.map((item: { key: string | number }) => (
        <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
      ))} */}
{/* 
<span>
                    <Checkbox
                        label={replyContent}
                        checked={isChecked} 
                        onChange={()=>{onChange()}}
                    >
                                           
                        </Checkbox>              
                    {reply.content}

                </span>         */}

{/* <li key={create_UUID()}>
    <a href={message.webUrl}>{message.content.substr(0,50)} </a>
    </li> */}

// function App() {
//   return (
//     <ThemeProvider theme={muiBaseTheme}>
//       <div>
//         <ChatMessages
        
//           avatar={AVATAR}
//           messages={[
//             "Hi Jenny, How r u today?",
//             "Did you train yesterday",
//             "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Volutpat lacus laoreet non curabitur gravida."
//           ]}
//         />
//         <ChatMessages
//           side={"right"}
//           messages={[
//             "Great! What's about you?",
//             "Of course I did. Speaking of which check this out"
//           ]}
//         />
//         <ChatMessages avatar={AVATAR} messages={["Im good.", "See u later."]} />
//       </div>
//     </ThemeProvider>
//   );
// }


// const replyStyle = () => {
    //     const _style =
    //        {
    //             textDecoration: "",
    //             color: "black",
    //             backgroundColor: "#e1dfdd"
    
    //         };
    //     return _style;
    //   };
    
    
    // return (
    //   <TextField
    //     key={uuidv4()}
    //     value={replyText}
    //     readOnly
    //     resizable={false}
    //     iconProps={{ iconName: 'Calendar' }}
    //     onClick={event => {
    //       //alert(`event ${JSON.stringify(event)}`)
    //       if (event.ctrlKey) {
    //         handleCtrlKey();
    //       }
    //     }}
    //     style={replyStyle()}
    //   />
    // );

    

      //   const activityItemExamples = [
  //     {
  //       key: 1,
  //       activityDescription: [
  //         <Link
  //           key={1}
  //           className={classNames.nameText}
  //           onClick={() => {
  //             alert('A name was clicked.');
  //           }}
  //         >
  //          {reply.user}
  //         </Link>,
  //         <span key={7}> replied:  </span>,
  //         <Link
  //           key={1}
  //           className={classNames.nameText}
  //           href={reply.webUrl}
  //         > 
  //            <Icon iconName={''} />
  //            <Icon iconName={'Message'} /> Teams
  //         </Link>,
  
  // <Link
  //           key={2}
  //           className={classNames.nameText}
  //           onClick={() => {
  //             handleCtrlKey();
  //           }}
  //         >
  //           <Icon iconName={''} /> 
  //           <Icon iconName={'Message'} /> Items[R]
  //         </Link>
  
  //       ],
  //       activityIcon: <Icon iconName={'Message'} />,
  //       comments: [
  //         <span key={1}>{reply.text.replace( /(<([^>]+)>)/ig, '')} </span>,
  //       ]
  //     }
  //   ];


      // const classNames = mergeStyleSets({
    //   exampleRoot: {
    //     marginTop: '20px',
    //     marginLeft: '20px',
    //     marginRight: '20px'
    //   },
    //   nameText: {
    //     fontWeight: 'bold'
    //   }
    // });
